import React, {lazy, Suspense} from 'react'
import { Link, graphql } from 'gatsby'

import Layout from '../components/layout'
import Seo from '../components/seo'
import * as videosStyles from './videos.module.scss'
import * as blogStyles from './blog.module.scss'

const VideoFrame = lazy(() => import("../components/VideoFrame"));

export const query = graphql`
    query($skip: Int!, $limit: Int!) {
        allYoutubeVideo (
            sort: {publishedAt: DESC},
            skip: $skip,
            limit: $limit)
            {
            edges {
                node {

                        title
                        videoId
                        publishedAt(formatString: "MMMM DD, YYYY")
                    }
                }
            }
    }
    `
    const Videos = (props) => {
    return (
        <div>
            <Layout>
                <Seo 
                    title="Videos"
                    description="All of my YouTube videos about travel, vegan life, and anything else I feel like makin a video about." 
                    path="/videos"
                    />
                <div className={`ss-container ${videosStyles.container}`}>
                    <h1 className={`heading`}>Videos</h1>
                    <div className={videosStyles.subscribeBlock} id={videosStyles.subscribeBlockYellow}>
                        <p className={videosStyles.subscribe}>Subscribe:{` `}</p>
                        <div className="g-ytsubscribe" data-channelid="UCjKLqaZuRg20F46v8yCz4wA" data-layout="default" data-count="hidden"></div>
                    </div>
                    <div className={videosStyles.videosContainer}>
                    {props.data.allYoutubeVideo.edges.map((edge) => {
                        return (
                        <div key={edge.node.title} className={videosStyles.videoBlock}>
                            <Suspense fallback={<div>Loading...</div>}>
                            <VideoFrame className={videosStyles.video} title={edge.node.video} width="493" height="277" src={`https://www.youtube.com/embed/${edge.node.videoId}`} ></VideoFrame>
                            </Suspense>
                            <p className={videosStyles.videoDate}>{edge.node.publishedAt}</p>
                            <h4 className={videosStyles.videoTitle}>{edge.node.title}</h4>
                        </div>
                        )
                    })}
                    </div>
                    <div className={videosStyles.subscribeBlock}>
                        <p className={videosStyles.subscribe}>Subscribe:{` `}</p>
                        <div className="g-ytsubscribe" data-channelid="UCjKLqaZuRg20F46v8yCz4wA" data-layout="default" data-count="hidden"></div>
                    </div>
                    {props.pageContext.numberOfPages > 1 ? 
                    <div className={blogStyles.pagination}>
                        
                        <div className={blogStyles.pageNavBar}>
                        { props.pageContext.pageNumber !== 0 ?
                            <Link className={blogStyles.pageNav} to={props.pageContext.previousPagePath}>&larr; Previous</Link> 
                            : <div className={blogStyles.pageNav}></div>}
                            <div className={blogStyles.currentPage}>
                        Page {props.pageContext.pageNumber + 1} of {props.pageContext.numberOfPages}
                        </div>
                        { props.pageContext.pageNumber + 1 !== props.pageContext.numberOfPages ? 
                        <Link className={blogStyles.pageNav} id={blogStyles.next} to={props.pageContext.nextPagePath}>Next &rarr;</Link>
                            : 
                            <div className={blogStyles.pageNav} id={blogStyles.next}></div>
                            }
                        </div>
                    </div>
                    : <div></div>}
                </div>
            </Layout>
        </div>
    )
}

export default Videos